module.exports = __webpack_public_path__ + "static/media/icon_consistency-data-issue.f94378ad.svg";